import { render, staticRenderFns } from "./chat-message-list.vue?vue&type=template&id=bbd4b096&"
import script from "./chat-message-list.vue?vue&type=script&lang=js&"
export * from "./chat-message-list.vue?vue&type=script&lang=js&"
import style0 from "./chat-message-list.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "chat-message-list.vue"
export default component.exports